import { render, staticRenderFns } from "./LinkedInGray.vue?vue&type=template&id=711f8af3&scoped=true&"
import script from "./LinkedInGray.vue?vue&type=script&lang=js&"
export * from "./LinkedInGray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f8af3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711f8af3')) {
      api.createRecord('711f8af3', component.options)
    } else {
      api.reload('711f8af3', component.options)
    }
    module.hot.accept("./LinkedInGray.vue?vue&type=template&id=711f8af3&scoped=true&", function () {
      api.rerender('711f8af3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/LinkedInGray.vue"
export default component.exports